<p>discord-test works!</p>
<iframe src="https://discord.com/widget?id=773475946597842954&theme=dark" width="350" height="500" allowtransparency="true" frameborder="0" sandbox="allow-popups allow-popups-to-escape-sandbox allow-same-origin allow-scripts"></iframe>


<div class="widgetHeader-2Hz_Ln">
    <div class="discord-logo widgetLogo-6zH6Nv"></div>
    <div class="button-container">
        <a href="http://localhost:8899/discord/login" target="_blank" class="widgetBtnConnect-2fvtGa">Connect</a>
    </div>
</div>
<!-- <script src="https://cdn.jsdelivr.net/npm/@widgetbot/crate@3" async defer>
    new Crate({
        server: '773475946597842954',
        channel: '773475946597842956',
    })
</script> -->
<div #script style.display="none">
    <!-- new Crate({ server: '773475946597842954', channel: '773475946597842956', }) -->
</div>

<div #heading style.display="none">
    Hello World
</div>

<h3>Test</h3>
